import type { cn } from '@sshop/ui';

export const headerStyles = {
  root: 'z-sticky border-border-subtle bg-bg-canvas/90 supports-[backdrop-filter]:bg-bg-canvas/75 sticky top-0 border-b backdrop-blur',
  container:
    'grid min-h-16 grid-cols-[auto_minmax(0,1fr)] items-center gap-x-1 gap-y-2 py-2 min-[1274px]:flex min-[1274px]:h-16 min-[1274px]:flex-nowrap min-[1274px]:gap-x-6 min-[1274px]:py-0',
  brand:
    'shrink-0 rounded-md outline-none focus-visible:ring-2 focus-visible:ring-accent focus-visible:ring-offset-2',
  nav: 'hidden shrink-0 items-center gap-1 min-[1274px]:flex',
  search:
    'col-span-2 row-start-2 flex min-w-0 w-full items-center gap-1 min-[1274px]:order-none min-[1274px]:flex-1',
  searchField: 'min-w-0 flex-1',
  actions:
    'col-start-2 row-start-1 ml-auto flex min-w-0 shrink-0 items-center justify-end gap-0 sm:gap-1',
  iconButton:
    'text-fg-secondary hover:text-fg-primary hover:bg-bg-subtle inline-flex h-11 w-11 items-center justify-center rounded-md transition-colors duration-fast ease-token',
  iconGlyph: 'h-5 w-5',
  divider: 'bg-border-subtle mx-1 hidden h-6 w-px min-[1274px]:block',
  desktopAction: 'hidden min-[1274px]:block',
  dealsLink:
    'text-fg-secondary hover:text-accent hover:bg-bg-subtle inline-flex h-10 items-center gap-1.5 rounded-full px-3 text-sm font-semibold transition-colors duration-fast ease-token',
  mobileDealsLink:
    'text-fg-secondary hover:text-accent hover:bg-bg-subtle inline-flex h-11 shrink-0 items-center gap-1.5 rounded-full px-3 text-sm font-semibold transition-colors duration-fast ease-token min-[1274px]:hidden',
  // Kept for back-compat with any other consumer; no longer used by Header itself.
  navItemBase:
    'relative inline-flex h-11 items-center px-1 text-sm font-medium transition-colors duration-fast ease-token',
  navItemActive: 'text-fg-primary',
  navItemInactive: 'text-fg-secondary hover:text-fg-primary',
  navItemUnderline:
    'after:absolute after:inset-x-0 after:bottom-0 after:h-0.5 after:rounded-full after:bg-accent after:transition-transform after:duration-base after:ease-token',
  navItemUnderlineOn: 'after:scale-x-100',
  navItemUnderlineOff: 'after:scale-x-0',
} as const;

export const headerNavItemClass =
  (cnFn: typeof cn) =>
  ({ isActive }: { isActive: boolean }) =>
    cnFn(
      headerStyles.navItemBase,
      isActive ? headerStyles.navItemActive : headerStyles.navItemInactive,
      headerStyles.navItemUnderline,
      isActive ? headerStyles.navItemUnderlineOn : headerStyles.navItemUnderlineOff,
    );
